import { render, staticRenderFns } from "./ModalPartita.vue?vue&type=template&id=d28b857a"
import script from "./ModalPartita.vue?vue&type=script&lang=js"
export * from "./ModalPartita.vue?vue&type=script&lang=js"
import style0 from "./ModalPartita.vue?vue&type=style&index=0&id=d28b857a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports